import { useState, useEffect, useContext } from 'react';
import { BrowserFeatureContext } from '@wix/da-react-context/pkg/BrowserFeatureContext';
export function useSupportsNativeLazyLoading() {
    const { supportsLazy: defaultValue } = useContext(BrowserFeatureContext);
    const [supportsLazy, setSupportsLazy] = useState(defaultValue);
    useEffect(()=>{
        if (typeof HTMLImageElement !== 'undefined' && 'loading' in HTMLImageElement.prototype) {
            setSupportsLazy(true);
        } else {
            setSupportsLazy(false);
        }
    }, []);
    return supportsLazy;
}

//# sourceMappingURL=useSupportsNativeLazyLoading.js.map